import { render } from "./ServerSettings.vue?vue&type=template&id=588d9373&ts=true"
import script from "./ServerSettings.vue?vue&type=script&lang=ts"
export * from "./ServerSettings.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/Spark/Spark/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__